"use strict";

var validateEmail = function validateEmail(str) {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(str);
};
$(function () {
  var $commit_password_mail = $("#commit_password_mail"),
    $reset_password_mail = $("#reset_password_mail"),
    $s_success = $(".s-success"),
    $s_main = $(".s-main");
  //弹窗元素
  var $alert = $(".s-mask-alert"),
    $alertMsg = $(".s-alert-msg"),
    $alertClose = $(".s-alert-close");
  $commit_password_mail.on("click", function () {
    var mail = $reset_password_mail.val();
    if (validateEmail(mail)) {
      //ajax请求邮箱是否发送成功，并进行一下操作；
      //    $s_main.addClass("display-none");
      //    $s_success.removeClass("display-none");
    } else {
      $alertMsg.html("输入的邮箱不合法！");
      $alert.show();
    }
  });
  $alertClose.on("click", function () {
    $alert.hide();
  });
});